import Link from '../Link/Link';

import './SearchCanceledHints.scss';

export type HintWithLinkProps = {
  href: string;
};
export function HintWithLink({ href }: HintWithLinkProps): JSX.Element {
  return (
    <div className="HintWithLink">
      &#8627; You can edit it, shorten the time range, or&nbsp;
      <Link href={href} className="HintWithLink__Link">click here</Link>
      &nbsp;to start a new search.
    </div>
  );
}
